import { OssOther } from 'utils/const.js';
export const calcSerial = (type, index) => {
    // 大闹天宫
    if (type == 0 && index == 0) return 7;
    if (type == 0 && index == 1) return 10;
    if (type == 0 && index == 2) return 11;
    if (type == 0 && index == 3) return 12;
    // 海底龙宫
    if (type == 1 && index == 0) return 13;
    if (type == 1 && index == 1) return 14;
    if (type == 1 && index == 2) return 15;
    if (type == 1 && index == 3) return 20;
    // 再见花果山
    if (type == 2 && index == 0) return 21;
    if (type == 2 && index == 1) return 22;
    if (type == 2 && index == 2) return 23;
    if (type == 2 && index == 3) return 24;
}

// 时间格式化
export const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `${minutes}:${secs}`;
};

export const formatDateY = (timestamp) => {
    const date = new Date(timestamp * 1000); // JavaScript的Date对象以毫秒为单位，因此需要将秒数乘以1000
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始计数，故需加1
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const formatTimeHM = (seconds) => {
    if (typeof seconds !== 'number') return
    const hours = Math.floor(seconds / 3600).toString(); // 计算小时数
    const remainingSeconds = seconds % 3600; // 计算剩余的秒数
    const minutes = Math.floor(remainingSeconds / 60).toString(); // 计算分钟数
    // 注意：这里不再需要计算单独的秒数，因为我们只想要小时和分钟
    return `${hours}时${minutes}分`;
};

export const formatDateYMD = (timestamp) => {
    // 提取年份
    // 创建一个新的 Date 对象
    const date = new Date(timestamp * 1000); // 时间戳通常为毫秒，所以乘以1000

    // 获取各个部分
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1，并且用padStart保证两位数
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // 拼接成所需的格式
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
}
export const formatDateHMS = (timestamp) => {
    // 提取年份
    // 创建一个新的 Date 对象
    const date = new Date(timestamp * 1000); // 时间戳通常为毫秒，所以乘以1000

    // 获取各个部分
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1，并且用padStart保证两位数
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // 拼接成所需的格式
    const formattedDate = `${hours}:${minutes}:${seconds}`;

    return formattedDate;
}

export const serialName = (id) => {
    if (id === 7) return '凌霄宝殿';
    if (id === 10) return '广寒宫';
    if (id === 11) return '蟠桃园';
    if (id === 12) return '兜率宫';
    if (id === 13) return '水晶宫';
    if (id === 14) return '珍珠宝殿';
    if (id === 15) return '龙吟殿';
    if (id === 20) return '珊瑚迷宫';
    if (id === 21) return '水帘洞';
    if (id === 22) return '灵猴峰';
    if (id === 23) return '云雾瀑布';
    if (id === 24) return '蝴蝶谷';
    // 影视模块（小雷音寺）：名称需与入口 icon 文案保持一致
    if (id === 985) return '读经小士';
    if (id === 986) return '学法小徒';
    if (id === 987) return '巧答小仙';
    if (id === 988) return '智慧小圣';
    if (id === 989) return '智慧中圣';
    if (id === 990) return '学法中徒';
    if (id === 991) return '读经中士';
    if (id === 992) return '学法高徒';
    if (id === 993) return '读经高士';
    if (id === 994) return '智慧大圣';
    if (id === 995) return '博学天尊';
    if (id === 996) return '预留入口';
    return '';
}
export function getUrlParams(url) {
    // 创建一个URL对象（仅在支持URL对象的现代浏览器中有效）
    const urlObj = new URL(url);
    // 获取查询字符串部分，并去除开头的问号（?）
    const queryString = urlObj.search.substring(1);
    // 将查询字符串分割成键值对数组
    const paramsArray = queryString.split('&');
    // 创建一个空对象来存储参数
    const params = {};

    // 遍历键值对数组，并将每个键值对添加到params对象中
    paramsArray.forEach(param => {
        const [key, value] = param.split('=');
        // 解码URL组件，以防参数中包含特殊字符
        params[decodeURIComponent(key)] = decodeURIComponent(value || '');
    });

    return params;
}

export function calcSkill(rank) {
    //const rank = 2
    switch (Number(rank)) {
        case 1:
            return [
                { name: '火眼金睛', number: 1, src: OssOther + '/image/skill/skill1.png', level: 1, visible: true },
                { name: '金币', number: '等级: 0', src: OssOther + '/image/skill/skill3.png', level: 0, visible: false },
                { name: '幸运', number: '等级: 0', src: OssOther + '/image/skill/skill2.png', level: 0, visible: false },
                { name: '星星', number: '等级: 0', src: OssOther + '/image/skill/skill4.png', level: 0, visible: false },
            ]
        case 2:
            return [
                { name: '火眼金睛', number: 1, src: OssOther + '/image/skill/skill1.png', level: 1, visible: true },
                { name: '金币', number: '等级: 1', src: OssOther + '/image/skill/skill3.png', level: 1, visible: true },
                { name: '幸运', number: '等级: 0', src: OssOther + '/image/skill/skill2.png', level: 0, visible: false },
                { name: '星星', number: '等级: 0', src: OssOther + '/image/skill/skill4.png', level: 0, visible: false },
            ]
        case 3:
            return [
                { name: '火眼金睛', number: 2, src: OssOther + '/image/skill/skill1.png', level: 2, visible: true },
                { name: '金币', number: '等级: 2', src: OssOther + '/image/skill/skill3.png', level: 2, visible: true },
                { name: '幸运', number: '等级: 0', src: OssOther + '/image/skill/skill2.png', level: 0, visible: false },
                { name: '星星', number: '等级: 0', src: OssOther + '/image/skill/skill4.png', level: 0, visible: false },
            ]
        case 4:
            return [
                { name: '火眼金睛', number: 2, src: OssOther + '/image/skill/skill1.png', level: 3, visible: true },
                { name: '金币', number: '等级: 2', src: OssOther + '/image/skill/skill3.png', level: 2, visible: true },
                { name: '幸运', number: '等级: 1', src: OssOther + '/image/skill/skill2.png', level: 1, visible: true },
                { name: '星星', number: '等级: 0', src: OssOther + '/image/skill/skill4.png', level: 0, visible: false },
            ]
        case 5:
            return [
                { name: '火眼金睛', number: 3, src: OssOther + '/image/skill/skill1.png', level: 3, visible: true },
                { name: '金币', number: '等级: 3', src: OssOther + '/image/skill/skill3.png', level: 3, visible: true },
                { name: '幸运', number: '等级: 2', src: OssOther + '/image/skill/skill2.png', level: 2, visible: true },
                { name: '星星', number: '等级: 0', src: OssOther + '/image/skill/skill4.png', level: 0, visible: false },
            ]
        case 6:
            return [
                { name: '火眼金睛', number: 3, src: OssOther + '/image/skill/skill1.png', level: 4, visible: true },
                { name: '金币', number: '等级: 4', src: OssOther + '/image/skill/skill3.png', level: 4, visible: true },
                { name: '幸运', number: '等级: 3', src: OssOther + '/image/skill/skill2.png', level: 3, visible: true },
                { name: '星星', number: '等级: 0', src: OssOther + '/image/skill/skill4.png', level: 0, visible: false },
            ]
        case 7:
            return [
                { name: '火眼金睛', number: 4, src: OssOther + '/image/skill/skill1.png', level: 5, visible: true },
                { name: '金币', number: '满级', src: OssOther + '/image/skill/skill3.png', level: 5, visible: true },
                { name: '幸运', number: '满级', src: OssOther + '/image/skill/skill2.png', level: 5, visible: true },
                { name: '星星', number: '满级', src: OssOther + '/image/skill/skill4.png', level: 1, visible: true },
            ]
        case 8:
            return [
                { name: '火眼金睛', number: 4, src: OssOther + '/image/skill/skill1.png', level: 5, visible: true },
                { name: '金币', number: '满级', src: OssOther + '/image/skill/skill3.png', level: 5, visible: true },
                { name: '幸运', number: '满级', src: OssOther + '/image/skill/skill2.png', level: 6, visible: true },
                { name: '星星', number: '满级', src: OssOther + '/image/skill/skill4.png', level: 1, visible: true },
            ]
        case 9:
            return [
                { name: '火眼金睛', number: 5, src: OssOther + '/image/skill/skill1.png', level: 6, visible: true },
                { name: '金币', number: '满级', src: OssOther + '/image/skill/skill3.png', level: 6, visible: true },
                { name: '幸运', number: '满级', src: OssOther + '/image/skill/skill2.png', level: 6, visible: true },
                { name: '星星', number: '满级', src: OssOther + '/image/skill/skill4.png', level: 1, visible: true },
            ]
        case 10:
            return [
                { name: '火眼金睛', number: 5, src: OssOther + '/image/skill/skill1.png', level: 6, visible: true },
                { name: '金币', number: '满级', src: OssOther + '/image/skill/skill3.png', level: 6, visible: true },
                { name: '幸运', number: '满级', src: OssOther + '/image/skill/skill2.png', level: 7, visible: true },
                { name: '星星', number: '满级', src: OssOther + '/image/skill/skill4.png', level: 1, visible: true },
            ]
        case 11:
            return [
                { name: '火眼金睛', number: 6, src: OssOther + '/image/skill/skill1.png', level: 7, visible: true },
                { name: '金币', number: '满级', src: OssOther + '/image/skill/skill3.png', level: 7, visible: true },
                { name: '幸运', number: '满级', src: OssOther + '/image/skill/skill2.png', level: 7, visible: true },
                { name: '星星', number: '满级', src: OssOther + '/image/skill/skill4.png', level: 1, visible: true },
            ]
        case 12:
            return [
                { name: '火眼金睛', number: 6, src: OssOther + '/image/skill/skill1.png', level: 8, visible: true },
                { name: '金币', number: '满级', src: OssOther + '/image/skill/skill3.png', level: 8, visible: true },
                { name: '幸运', number: '满级', src: OssOther + '/image/skill/skill2.png', level: 8, visible: true },
                { name: '星星', number: '满级', src: OssOther + '/image/skill/skill4.png', level: 1, visible: true },
            ]
        case 13:
            return [
                { name: '火眼金睛', number: 7, src: OssOther + '/image/skill/skill1.png', level: 9, visible: true },
                { name: '金币', number: '满级', src: OssOther + '/image/skill/skill3.png', level: 9, visible: true },
                { name: '幸运', number: '满级', src: OssOther + '/image/skill/skill2.png', level: 9, visible: true },
                { name: '星星', number: '满级', src: OssOther + '/image/skill/skill4.png', level: 1, visible: true },
            ]
        case 14:
            return [
                { name: '火眼金睛', number: 7, src: OssOther + '/image/skill/skill1.png', level: 10, visible: true },
                { name: '金币', number: '满级', src: OssOther + '/image/skill/skill3.png', level: 10, visible: true },
                { name: '幸运', number: '满级', src: OssOther + '/image/skill/skill2.png', level: 10, visible: true },
                { name: '星星', number: '满级', src: OssOther + '/image/skill/skill4.png', level: 1, visible: true },
            ]
        case 15:
            return [
                { name: '火眼金睛', number: 8, src: OssOther + '/image/skill/skill1.png', level: 11, visible: true },
                { name: '金币', number: '满级', src: OssOther + '/image/skill/skill3.png', level: 11, visible: true },
                { name: '幸运', number: '满级', src: OssOther + '/image/skill/skill2.png', level: 11, visible: true },
                { name: '星星', number: '满级', src: OssOther + '/image/skill/skill4.png', level: 1, visible: true },
            ]
        case 16:
            return [
                { name: '火眼金睛', number: 8, src: OssOther + '/image/skill/skill1.png', level: 12, visible: true },
                { name: '金币', number: '满级', src: OssOther + '/image/skill/skill3.png', level: 12, visible: true },
                { name: '幸运', number: '满级', src: OssOther + '/image/skill/skill2.png', level: 12, visible: true },
                { name: '星星', number: '满级', src: OssOther + '/image/skill/skill4.png', level: 1, visible: true },
            ]
        default:
    }
}
